var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validating-header"},[_c('h2',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"validating-header__actions"},[_c('p',{staticClass:"validating-header__name"},[_vm._v("Проверяющие")]),_c('ButtonGroups')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }